import styled from "styled-components";

export const FormElemWrapperComponent = styled.div`
    width: 100%;
    margin: 1rem 0;
`;

export default FormElemWrapperComponent;